<template lang="pug">
.popupOption.show--smallScreens(@click="$emit('closePopup')")
  ul.popupOption-list(v-if="sortConfig.type == 'government'")
    li.popupOption-item(:class='checkType("createdAt-1")' @click="sortByType('createdAt', -1)") 時間由新至舊
    li.popupOption-item(:class='checkType("createdAt1")' @click="sortByType('createdAt', 1)") 時間由舊至新
  ul.popupOption-list(v-else-if="sortConfig.type == 'partners'")
    li.popupOption-item(:class='checkType("updatedAt-1")' @click="sortByType('updatedAt', -1)") 時間由新至舊
    li.popupOption-item(:class='checkType("updatedAt1")' @click="sortByType('updatedAt', 1)") 時間由舊至新
  ul.popupOption-list(v-else)
    li.popupOption-item(:class='checkType("time-1")' @click="sortByType('time', -1)") 時間由新至舊
    li.popupOption-item(:class='checkType("reporterCount1")' @click="sortByType('reporterCount', 1)") 回報數由小至大
    li.popupOption-item(:class='checkType("reporterCount-1")' @click="sortByType('reporterCount', -1)") 回報數由大至小
    li.popupOption-item(:class='checkType("followerCount1")' @click="sortByType('followerCount', 1)") 關注數由小至大
    li.popupOption-item(:class='checkType("followerCount-1")' @click="sortByType('followerCount', -1)") 關注數由大至小
</template>
<script>
export default {
  props: {
    sortType: String,
    sortConfig: Object
  },
  methods: {
    checkType(sortType) {
      const _checkType = this.sortType
        ? this.sortType.replace('tag.id', 'time')
        : this.sortType;
      if (_checkType === sortType) return 'popupOption-item--active';
      return '';
    },
    sortByType(sortType, direction) {
      if (sortType == 'time' && direction == -1) this.$emit('sortByType', {});
      else {
        this.$emit('sortByType', {
          type: sortType,
          direction: direction
        });
      }
    }
  }
};
</script>
